import { ProductV2, isGemPackOffer } from '@common'

import { CardSingleProduct, ProductCardContentType } from '../../_storeBase/card/CardSingleProduct'
import SideScrollable from '../../_storeBase/structure/SideScrollable'
import { ProductCategoryHeader } from './ProductCategoryHeader'

import styles from './ProductCategory.module.scss'

interface ProductCategoryProps {
  title: string
  products: ProductV2[]
  productType: ProductCardContentType
}

export const ProductCategory = ({ title, products, productType }: ProductCategoryProps) => {
  const gems = products.filter(isGemPackOffer)

  return (
    <div className={styles.ProductCategory}>
      <ProductCategoryHeader title={title} />
      <SideScrollable className={styles.ProductCardContainer}>
        {gems.map((product, index) => (
          <CardSingleProduct key={index} product={product} productType={productType} />
        ))}
      </SideScrollable>
    </div>
  )
}
